import { useContext } from 'react';

import {
  ColSize,
  ContentSection,
  Form,
  RowSize,
  SelectForm,
} from '../../../../../../../../../shared/components';
import { QuotationStepButtons } from '../../../../../shared';

import { QuotationInfoContext } from '../../../../../shared/contexts';
import { QuotationStep } from '../../../../../shared/interfaces';
import { StepTwoFormContext } from '../../contexts/StepTwoForm';
import { WizardDataFormContext } from '../../../../Wizard/contexts/WizardDataForm';

import { ValidateForm } from '../../../../../../../../../shared/utils';

import './index.css';
import { ActividadesComercio } from '../../../../../../../../../shared/interfaces';
import { message } from 'antd';

export const CategorySelection = () => {
  const validateForm = new ValidateForm();

  const { rubricList, rubricListOptions } = useContext(WizardDataFormContext);
  const { setCurrentStep } = useContext(QuotationInfoContext);
  const { stepTwoForm, setRubricSelected } = useContext(StepTwoFormContext);

  const onValidateForm = async () => {
    try {
      await stepTwoForm?.validateFields();
      const rubric = stepTwoForm?.getFieldValue('category') as string;
      const rubricSelected = rubricList?.actividadesComercio.find(
        (item: ActividadesComercio) =>
          `${item.capituloTarifa}${item.capituloTarifaInciso1}${item.capituloTarifaInciso2}` === rubric
      );
      if (rubricSelected?.codigoDeRiesgo === "") {
        message.error("La opción seleccionada no es válida. Por favor, seleccione otra.");
        return;
      }
      setRubricSelected(rubricSelected);

      setCurrentStep(QuotationStep.THREE);
    } catch (error) {}
  };

  return (
    <Form
      formProps={{
        form: stepTwoForm,
        name: 'category-selection-form',
      }}
    >
      <ContentSection level='h3' title='Rubro'>
        <RowSize>
          <ColSize size={25}>
            <SelectForm
              formProps={{
                label: 'Rubro:',
                name: 'category',
                rules: validateForm.generateRules({
                  label: 'rubro',
                  rules: ['required'],
                }),
              }}
              selectProps={{ 
                options: rubricListOptions,
                loading: !rubricListOptions.length,
                disabled: !rubricListOptions.length
              }}
            />
          </ColSize>
        </RowSize>
      </ContentSection>

      <QuotationStepButtons
        label='Continuar'
        onClick={onValidateForm}
        onPressBackButton={() => setCurrentStep(QuotationStep.ONE)}
      />
    </Form>
  );
};
